<iframe [height]="maxSize? '100%' : '0px'" allowtransparency="true" [attr.PluginName]="plugin.name"
  [attr.AppLayer]="plugin.layer" [src]="src" [class.hidden]="!plugin.visible" [class.plugin]="true"
  allow="geolocation; microphone; camera; speaker-selection; midi; encrypted-media; local-network-access"></iframe>
